import { render } from "./SongEditor.vue?vue&type=template&id=71e62e4e&scoped=true"
import script from "./SongEditor.vue?vue&type=script&lang=js"
export * from "./SongEditor.vue?vue&type=script&lang=js"

import "./SongEditor.vue?vue&type=style&index=0&id=71e62e4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71e62e4e"

export default script